/*
 * The rules behind a Segmented's form, kept apart from it so they can be checked without a browser.
 */

/** How a Segmented draws its choices: side by side, two to a row, or a Select of them. */
export type SegmentedForm = "row" | "grid" | "select"

/**
 * The desk always draws a row. On `compact` a row holds four choices at most, which a phone's width
 * can hold side by side; past that it is a Select. A caller whose choices read as words rather than
 * a word each (a change request's Kind: "A bug", "Not sure") asks for two columns on `compact`
 * (`columnsOnCompact`), a grid of rows of two, however many choices it has.
 */
export function segmentedFormOf({
  compact,
  choices,
  columnsOnCompact,
}: {
  compact: boolean
  choices: number
  columnsOnCompact: 2 | undefined
}): SegmentedForm {
  if (!compact) return "row"
  if (columnsOnCompact) return "grid"
  return choices > 4 ? "select" : "row"
}
